export const calculateYearsOfExperience = (startYear) => {
  const currentYear = new Date().getFullYear();
  return currentYear - startYear;
};
